export default [
  {
    path: '/zjd/supplyMaterial', // 补充材料
    name: 'supplyMaterial',
    component: () => {
      return import(
        /* webpackChunkName: "common" */ '@/views/common/supplyMaterial.vue'
      )
    }
  },
  {
    path: '/submittedMaterials', // 已提交的材料
    name: 'submittedMaterials',
    component: () => {
      return import(
        /* webpackChunkName: "common" */ '@/views/common/submittedMaterials.vue'
      )
    }
  }
]
